
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientCompanyProfileResource,
  ClientCompanySettingsProfileUpdateRequest,
} from '../models';
import {
    ClientCompanyProfileResourceFromJSON,
    ClientCompanyProfileResourceToJSON,
    ClientCompanySettingsProfileUpdateRequestFromJSON,
    ClientCompanySettingsProfileUpdateRequestToJSON,
} from '../models';

export interface GetCompanyProfileRequest {
    companyId: string;
}

export interface UpdateCompanyProfileRequest {
    companyId: string;
    clientCompanySettingsProfileUpdateRequest: ClientCompanySettingsProfileUpdateRequest;
}

/**
 * 
 */
export class ClientCompanyProfileApi extends runtime.BaseAPI {

    /**
          */
    async getCompanyProfileRaw(requestParameters: GetCompanyProfileRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyProfileResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompanyProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientCompanyProfileResource>({
            path: `/client-settings/api/{companyId}/profile`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyProfileResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCompanyProfile(requestParameters: GetCompanyProfileRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyProfileResource> {
        const response = await this.getCompanyProfileRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async updateCompanyProfileRaw(requestParameters: UpdateCompanyProfileRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyProfileResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateCompanyProfile().'
            );
        }

        if (requestParameters['clientCompanySettingsProfileUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'clientCompanySettingsProfileUpdateRequest',
                'Required parameter "clientCompanySettingsProfileUpdateRequest" was null or undefined when calling updateCompanyProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientCompanyProfileResource>({
            path: `/client-settings/api/{companyId}/profile`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanySettingsProfileUpdateRequestToJSON(requestParameters['clientCompanySettingsProfileUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyProfileResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async updateCompanyProfile(requestParameters: UpdateCompanyProfileRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyProfileResource> {
        const response = await this.updateCompanyProfileRaw(requestParameters, initOverrides);
        return response._data;
    }

}
